import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CookieConsentPreferences {
	essential: true;
	preference: boolean;
	performance: boolean;
	marketing: boolean;
}

export type CookieConsentValue = CookieConsentPreferences | null;

const COOKIE_CONSENT_KEY = 'cookie_consent';

export interface CookieConsentState {
	value: CookieConsentValue;
}

function parseStored(): CookieConsentValue {
	if (typeof window === 'undefined') return null;
	const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
	if (!raw) return null;
	try {
		const parsed = JSON.parse(raw);
		if (typeof parsed === 'boolean') {
			localStorage.removeItem(COOKIE_CONSENT_KEY);
			return null;
		}
		return parsed as CookieConsentPreferences;
	} catch {
		return null;
	}
}

const initialState: CookieConsentState = {
	value: parseStored(),
};

export const cookieConsentSlice = createSlice({
	name: 'cookieConsent',
	initialState,
	reducers: {
		setCookieConsent(state, action: PayloadAction<CookieConsentValue>) {
			state.value = action.payload;
		},
	},
});

export const { setCookieConsent } = cookieConsentSlice.actions;
